import { Graphics } from "@/components/graphics";
import { Locales } from "@/lib/i18n";
import { __ } from "@/lib/i18n/functions";
import { cn } from "@/lib/utils";
import { ContactDocumentData } from "@/prismicio-types";
import { PrismicNextLink } from "@prismicio/next";
import { PrismicRichText } from "@prismicio/react";
import { ClockIcon, PhoneIcon } from "lucide-react";
import Link from "next/link";

type ContactDetailsProps = {
  className?: string;
  data: ContactDocumentData;
  locale: Locales;
};

const ContactDetails = ({ className, data, locale }: ContactDetailsProps) => {
  return (
    <div className={cn("space-y-5", className)}>
      <div className="text-dark-primary flex items-center justify-center gap-7.5 bg-[#F8F6F6] px-3.5 py-3 max-sm:flex-col">
        <Link
          href={`tel:${data.phone}`}
          className="flex flex-1 items-center justify-end gap-2.5 text-left max-sm:flex-col"
        >
          <PhoneIcon size={22} aria-hidden="true" strokeWidth={2} />
          <p>{data.phone}</p>
        </Link>
        <div className="flex flex-1 items-center gap-2.5 max-sm:flex-col">
          <ClockIcon size={22} aria-hidden="true" className="shrink-0" strokeWidth={2} />
          <div className="space-y-2">
            <PrismicRichText
              field={data.working_hours}
              components={{
                paragraph: ({ children }) => <p className="leading-h1 text-balance max-sm:text-center">{children}</p>,
              }}
            />
          </div>
        </div>
      </div>
      <PrismicNextLink field={data.instagram_link} className="flex items-center justify-center gap-2.5 px-3.5 py-3">
        <Graphics.insta />
        {data.instagram_link.text || __("Follow us on Instagram", locale)}
      </PrismicNextLink>
    </div>
  );
};

export default ContactDetails;
